// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * 
 */
enum GraphicSealState {
    TRUE = 'TRUE', 
    FALSE = 'FALSE', 
    NOT_CONFIGURED = 'NOT_CONFIGURED'
};
export default GraphicSealState;

